import React from "react";
import App from "./App";
import { createRoot } from "react-dom/client";
import { KeycloakContext } from "./helpers/KeycloakContext";
import { AccountServiceClient } from "./services/account-service/account.service";
import { AccountServiceContext } from "./services/account-service/AccountServiceContext";
import Keycloak from "keycloak-js";
const container = document.getElementById("root");
const root = createRoot(container);
const initOptions = {
    pkceMethod: "S256",
    promiseType: "native",
    onLoad: "login-required",
    checkLoginIframe: false
};
const keycloak = new Keycloak({
    url: keycloakUrl,
    realm: realm,
    clientId: clientId
});
keycloak.init(initOptions).then(() => {
    root.render(React.createElement(React.StrictMode, null,
        React.createElement(KeycloakContext.Provider, { value: keycloak },
            React.createElement(AccountServiceContext.Provider, { value: new AccountServiceClient(keycloak) },
                React.createElement(App, null)))));
});
